import React from "react";
import { accountStatusMeta } from "@/lib/companyTypes";

/**
 * Colour-coded account-status pill per Batch-1 spec.
 * Green = Active, Amber = Pending Activation, Orange = Temporarily Disabled,
 * Red = Suspended, Gray = Expired, Dark Gray = Deactivated.
 */
export default function AccountStatusBadge({ status, testId }) {
  const meta = accountStatusMeta(status);
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full"
      style={{ color: meta.color, background: meta.background }}
      data-testid={testId || `account-status-${status || "unknown"}`}
      title={meta.label}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ background: meta.dot }}
      />
      {meta.label}
    </span>
  );
}
